<template>
    <iframe v-if="src" :src="src" class="dashboard-frame" allow="clipboard-read; clipboard-write; microphone"></iframe>
</template>
<script>
import {httpClient} from "../../../services/HttpClient";

export default {
    name: 'DashboardPage',
    data() {
        return {
            widget: null,
        }
    },
    computed: {
        src() {
            if (!this.widget) {
                return null;
            }

            const url = new URL(this.widget.url);
            url.searchParams.set('token', this.widget.token);
            url.searchParams.set('project_uuid', this.$route.params.projectUuid);

            if (this.widget.fs_lead_id) {
                url.searchParams.set('fs_lead_id', this.widget.fs_lead_id);
            }

            return url.toString();
        },
    },
    async created() {
        const response = await httpClient.get(`/projects/${this.$route.params.projectUuid}/dashboard-widget`);

        this.widget = response.data.data;
    },
}
</script>
<style scoped>
.dashboard-frame {
    display: block;
    width: 100%;
    height: calc(100vh - 200px);
    min-height: 500px;
    border: 0;
}
</style>
